export default class APIResponse {
  _success = false;
  _data = null;
  _error = null;

  /**
   * Build an API response object for consumption by those who use the API.
   *
   * @param {boolean} success
   * @param {Object} data
   * @param {Error} error
   */
  constructor(success, data, error) {
    this._success = success;
    this._data = data;
    this._error = error;
  }

  get success() {
    return this._success;
  }

  get data() {
    return this._data;
  }

  get error() {
    return this._error;
  }
}
